import "core-js/modules/es.symbol";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import classNames from 'classnames';
import { Body, BodyExtra } from "../Text";
import Box from "../Box";

var NavItem = function NavItem(props) {
  var getIcon = function getIcon(icon) {
    switch (props.activeState) {
      case 'disabled':
        return icon.disabled || icon.default;

      case 'selected':
        return icon.selected || icon.default;

      case 'active':
        return icon.active || icon.hover || icon.default;

      case 'hover':
        return icon.hover || icon.default;

      default:
        return icon.default;
    }
  };

  var renderIcon = function renderIcon(icon) {
    if (!icon) {
      return null;
    }

    return /*#__PURE__*/React.createElement(Box, {
      padding: 2,
      margin: {
        right: 12
      },
      flex: {
        alignItems: 'center'
      }
    }, getIcon(icon));
  };

  var renderText = function renderText(indented) {
    var contents = props.contents;

    switch (props.activeState) {
      case 'disabled':
        return /*#__PURE__*/React.createElement(Body, {
          color: "disabled"
        }, contents);

      case 'selected':
        return /*#__PURE__*/React.createElement(BodyExtra, {
          color: "blue"
        }, contents);

      case 'hover':
      case 'active':
        return /*#__PURE__*/React.createElement(Body, {
          color: "dark"
        }, contents);

      default:
        return /*#__PURE__*/React.createElement(Body, {
          color: indented ? 'default' : 'dark'
        }, contents);
    }
  };

  var activeState = props.activeState,
      contents = props.contents,
      icon = props.icon,
      indentLevel = props.indentLevel,
      alignItems = props.alignItems,
      remaining = _objectWithoutProperties(props, ["activeState", "contents", "icon", "indentLevel", "alignItems"]); // Only one indent level necessary at this point.


  var indented = indentLevel > 0;
  var outerVerticalPadding = indented ? 2 : 4;
  var innerPadding = indented ? {
    left: 32
  } : null;
  var className = classNames(props.className, 'NavItem', {
    'NavItem--disabled': activeState === 'disabled'
  });
  return /*#__PURE__*/React.createElement(Box, _extends({}, remaining, {
    className: className,
    background: "surface",
    padding: {
      vertical: outerVerticalPadding,
      horizontal: 4
    }
  }), /*#__PURE__*/React.createElement(Box, {
    flex: {
      alignItems: alignItems
    },
    padding: innerPadding
  }, renderIcon(icon), renderText(indented)));
};

NavItem.defaultProps = {
  activeState: 'default',
  indentLevel: 0,
  alignItems: 'center'
};
export default NavItem;